import constantes from '../config/constantes';
import { getTokenLocalStorage } from '../config/tokenManager';
import { XhrSource } from './eventsourcePost';

export function criadorTipoAtendimentoStream(mensagens, modeloBaseId, { onText, onPromptCriado, onError, onClose }) {
    const endpoint = constantes.baseUrl + 'Prompt/criadorStream';
    const token = getTokenLocalStorage();

    const xs = XhrSource(endpoint, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mensagens, modeloBaseId: modeloBaseId || null }),
    });

    xs.addEventListener('message', (e) => {
        onText && onText(e.data.replace(/\\n/g, '\n'));
    });

    xs.addEventListener('prompt_criado', (e) => {
        try {
            const data = JSON.parse(e.data);
            onPromptCriado && onPromptCriado(data);
        } catch {
            onPromptCriado && onPromptCriado(null);
        }
    });

    xs.addEventListener('error', (e) => {
        onError && onError(e.data || 'Erro ao criar tipo de atendimento.');
    });

    xs.addEventListener('close', () => {
        onClose && onClose();
    });

    return xs;
}
